module.exports = __webpack_public_path__ + "static/media/welcome.eef5d9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/welcome.png
// module id = 72
// module chunks = 0